export function secondsToTime(s){return(s-(s%=60))/60+(9<s?':':':0')+s}
export function hoursMinSecStringToSecs(hms){
  const a = hms.split(':')
  return (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2])
}
export function getTimeIndex(timeArray, time) {
  return timeArray.findIndex((item) => {
    return item === `${time.split(':')[0]}:${time.split(':')[1]}`
  })
}
export function minutesToMilliseconds(minutes){
  return minutes * 60000
}
export function secondsToMilliseconds(seconds){
  return seconds * 1000
}
export function millisToMinutesSeconds(millis){
  var minutes = Math.floor(millis / 60000);
  var seconds = ((millis % 60000) / 1000).toFixed(0);
  return (seconds == 60 ? (minutes+1) + ":00" : minutes + ":" + (seconds < 10 ? "0" : "") + seconds);
}
export function msToTime(s) {

  // Pad to 2 or 3 digits, default is 2
  function pad(n, z) {
    z = z || 2;
    return ('00' + n).slice(-z);
  }

  var ms = s % 1000;
  s = (s - ms) / 1000;
  var secs = s % 60;
  s = (s - secs) / 60;
  var mins = s % 60;
  var hrs = (s - mins) / 60;

  return pad(hrs) + ':' + pad(mins) + ':' + pad(secs);
}


// WEBPACK FOOTER //
// ./src/helpers/TimeHelper.js